import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalenderAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCalenderAdd"><Path d="M9 2H7V4H3V21H12V19H5V10H19V12H21V4H17V2H15V4H9V2Z" fill="currentColor"/><Path d="M19 14H17V17H14V19H17V22H19V19H22V17H19V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalenderAdd;
